<template>
  <b-overlay :show="showOverlay">

    <div v-if="pageData && pageData.value">
      <b-card>
        <language-picker
            @getLanguage="setLanguage"
        ></language-picker>
      </b-card>

      <b-card v-if="pageMedia">
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Edit Banner video</h1>
          </b-col>

          <b-col class="mb-1" cols="12">
            <video playsinline controls preload="auto" :src="pageMedia" class="w-100" style="height: 30rem"/>
          </b-col>

          <b-col class="my-2" cols="12">
            <b-button
                class=""
                variant="warning"
                @click="$refs.refInputEl2.click()"
            >
              <input
                  accept=".webm,.mp4,.ogg"
                  ref="refInputEl2"
                  type="file"
                  class="d-none"
                  @change="setVideo"
              >
              <span class="">Update video</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col class="mb-1" cols="12">
            <h1>Edit texts</h1>
          </b-col>

          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="First text"
                label-for="first"
            >
              <b-form-input
                  id="first"
                  v-model="pageData.value.first"
                  dir="auto"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Second text"
                label-for="second"
            >
              <b-form-input
                  id="second"
                  v-model="pageData.value.second"
                  dir="auto"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Third text"
                label-for="third"
            >
              <b-form-input
                  id="third"
                  v-model="pageData.value.third"
                  dir="auto"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Fourth text"
                label-for="fourth"
            >
              <b-form-input
                  id="fourth"
                  v-model="pageData.value.fourth"
                  dir="auto"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
                class="mb-2"
                label="Fifth text"
                label-for="fifth"
            >
              <b-form-input
                  id="fifth"
                  v-model="pageData.value.fifth"
                  dir="auto"
              />
            </b-form-group>
          </b-col>

          <b-col class="my-2" cols="12">
            <b-button class="btn" type="button" variant="primary" @click="updateFooter">Submit changes</b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCarousel,
  BCarouselSlide,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {DynamicPagesGetBy, DynamicPagesGetByType, UpdateDynamicPages} from "@/libs/Api/DynamicPages";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import {GetLatestBannerVideo, MediaUpload} from "@/libs/Api/Media";
import {OrderUpdateMilestoneByAdmin} from "@/libs/Api/Order";

export default {
  name: "HomeBanners",
  title: "Home Banners",
  data() {
    return {
      showOverlay: false,
      languageList:[],
      rawHTML: '',
      languageId:1,
      pageData: null,
      pageMedia: null,
    }
  },
  watch: {
    languageId: {
      handler(val) {
        this.getPageData();
      },
    },
  },
  async created() {
    await this.getPageData();
    await this.getPageMedia();
  },
  methods: {
    async getPageData() {
      let _this = this;
      _this.showOverlay = true;

      let dynamicPagesGetBy = new DynamicPagesGetByType(_this);
      dynamicPagesGetBy.setParams({
        type: 6,
        LanguageId:_this.languageId
      })
      await dynamicPagesGetBy.fetch(function (content) {
        _this.showOverlay = false;
        _this.pageData = content.data;
        _this.pageData.value = JSON.parse(_this.pageData.value);
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async getPageMedia() {
      let _this = this;
      _this.showOverlay = true;

      let getLatestBannerVideo = new GetLatestBannerVideo(_this);
      await getLatestBannerVideo.fetch(function (content) {
        _this.showOverlay = false;
        _this.pageMedia = Helper.baseUrl+content.data;
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async updateFooter() {
      let _this = this;
      _this.showOverlay = true;

      let updateDynamicPages = new UpdateDynamicPages(_this);
      // _this.pageData.value['telegram'] = '';
      _this.pageData.value = JSON.stringify(_this.pageData.value);
      updateDynamicPages.setParams(_this.pageData);
      await updateDynamicPages.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getPageData();
      }, function (error) {
        console.log(error);
        _this.showOverlay = false;
      })
    },
    async setVideo(event) {
      let _this = this;
      _this.showOverlay = true;
      let file = event.target.files.item(0);
      let formData = new FormData();
      formData.append('Files', file);
      let mediaUpload = new MediaUpload(_this);
      mediaUpload.setParams({
        objectId:-6,
        type:28
      });
      mediaUpload.setFormPrams(formData);
      await mediaUpload.sendFormData((content) => {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Operation successful`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        window.location.reload();
      }, (error) => {
        _this.overlay = false;
        console.log(error)
      });
    },
    setLanguage(language) {
      this.languageId = language.languageId;
    },
    setEditorContent(content) {
      this.pageData.value.customFooter = content;
    },
    setEditorContentMobile(content) {
      this.pageData.value.customFooterMobile = content;
    },
  },
  components: {
    LanguagePicker,
    AddEditDeleteButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BFormFile,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BCarousel,
    BCarouselSlide,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BOverlay,
    BModal,
    BFormSelect,
    vSelect,
    BFormTextarea,
  },
}
</script>

<style scoped>

</style>
